import defaultItem from './defaultItem';
import lazyLoadComponent from "@/scripts/lazyLoadComponent";
import SkeletonBoxWithoutLoading from "@/components/SkeletonBoxWithoutLoading.vue";
import cashbackPolicyApi from '@/api/common/cashbackPolicyApi';
import _ from 'lodash';
import moment from 'moment';
export default {
    components: {        
        EditView: lazyLoadComponent({
            componentFactory: () => import("@/views/spentCashback/EditView.vue"),
            loading: SkeletonBoxWithoutLoading,
        }),    
    },
    data() {
        return {
            defaultItem,
            
            isShowEdit: false,
            editViewModel: null,
            
            // Data và pagination
            policies: [],
            loading: false,
            total: 0,
            currentPage: 1,
            pageSize: 10,
            
            filters: {
                querySearch: ''
            },
            
            // Loading states
            savingPolicy: false
        }
    },
    watch: {
        isShowEdit(val) {
            if(!val) this.editViewModel = null;
        },
        'filters.querySearch': {
            handler: function(newVal, oldVal) {
                // Chỉ gọi API khi giá trị thực sự thay đổi và không đang loading
                if (newVal !== oldVal && !this.loading) {
                    this.currentPage = 1;
                    this.debouncedLoadPolicies();
                }
            }
        }
    },
    created() {
        // Tạo debounced function
        this.debouncedLoadPolicies = _.debounce(this.loadPolicies, 500);
        this.loadPolicies();
    },
    methods: {
        showDetail(item) {
            // Navigate to detail page instead of showing modal
            this.$router.push(`/spent-cashback/detail/${item.id}`);
        },
        closeDetail(){
            this.isShowDetail = false;
            this.detailViewModel = null;
        },
        showEdit(item) {
            this.editViewModel = {
                ...item,
                startTime: item.startTime != null ? moment.utc(item.startTime).local() : null,
                endTime: item.endTime != null ? moment.utc(item.endTime).local() : null,
            };
            this.isShowEdit = true;
        },
        closeEdit(){
            this.isShowEdit = false;
            this.editViewModel = null;
        },
        createSamplePolicy(index) {
            return {
                id: index,
                name: `Sample Policy ${index}`,
                cashbackRate: index * 2,
                cashbackExpiryDays: index * 30,
                priority: index * 10,
                isActive: index % 2 === 0,
                startTime: '2026-02-01T00:00:00',
                endTime: '2026-12-31T23:59:59',
                daysOfWeek: index % 2 === 0 ? ',1,2,3,4,5,' : ',6,0,',
                timeRanges: index % 2 === 0 ? ',8,9,10,11,12,13,14,15,16,17,' : ',18,19,20,21,22,',
                userClassifyIds: index % 3 === 0 ? ',vip,premium,' : index % 3 === 1 ? ',standard,' : null,
                regionCodes: index % 2 === 0 ? ',VN,US,' : ',JP,KR,',
                packageIds: `,${index},${index + 10},${index + 20},`,
                userIds: null,
                excludeUserIds: null,
                billTypes: index % 2 === 0 ? ',fixrental,payusago,' : ',fixrental,',
                createdAt: '2026-01-01T00:00:00',
                createdBy: 'anhnv',
                lastModifiedAt: '2026-01-29T00:00:00',
                lastModifiedBy: 'anhnv'
            };
        },
        
        // Load policies từ API
        async loadPolicies() {
            // Tránh gọi API nếu đang loading
            if (this.loading) {
                return;
            }
            
            try {
                this.loading = true;
                const requestParams = {
                    page: this.currentPage,
                    pageSize: this.pageSize,
                    search: this.filters.querySearch || ''
                };
                
                const response = await cashbackPolicyApi.getAllPolicies(requestParams);
                
                if (response.data && response.data.result === 0) {
                    this.policies = (response.data.data && response.data.data.items) || [];
                    this.total = (response.data.data && response.data.data.total) || 0;
                } else {
                    this.policies = [];
                    this.total = 0;
                    console.error('API Error:', response.data);
                    // Chỉ hiển thị message khi không phải lần đầu load
                    if (this.$message) {
                        this.$message.error('Failed to load policies: ' + (response.data && response.data.message || 'Unknown error'));
                    }
                }
            } catch (error) {
                console.error('Error loading policies:', error);
                this.policies = [];
                this.total = 0;
                // Chỉ hiển thị message khi không phải lần đầu load và không phải lỗi network timeout
                if (this.$message && !error.message.includes('timeout') && !error.message.includes('Network Error')) {
                    this.$message.error('Error loading policies: ' + error.message);
                }
            } finally {
                this.loading = false;
            }
        },
        
        // Save hoặc update policy
        async savePolicy() {
            // Tránh gọi API nếu đang saving hoặc không có data
            if (this.savingPolicy || !this.editViewModel) {
                if (!this.editViewModel) {
                    this.$message.error('No policy data to save');
                }
                return;
            }
            
            try {
                this.savingPolicy = true;
                
                // Chuẩn bị payload
                const payload = {
                    ...this.editViewModel,
                    createdBy: 'anhnv',
                    lastModifiedBy: 'anhnv',
                    id: this.editViewModel.id || 0 // 0 cho tạo mới
                };
                
                const response = await cashbackPolicyApi.upsertPolicy(payload);
                
                if (response.data && response.data.result === 0) {
                    if (this.$message) {
                        this.$message.success(
                            payload.id === 0 
                                ? 'Policy created successfully!' 
                                : 'Policy updated successfully!'
                        );
                    }
                    this.isShowEdit = false;
                    this.editViewModel = null;
                    // Reload danh sách - chỉ khi không đang loading
                    if (!this.loading) {
                        await this.loadPolicies();
                    }
                } else {
                    if (this.$message) {
                        this.$message.error('Failed to save policy: ' + (response.data && response.data.message || 'Unknown error'));
                    }
                }
            } catch (error) {
                console.error('Error saving policy:', error);
                if (this.$message) {
                    this.$message.error('Error saving policy: ' + error.message);
                }
            } finally {
                this.savingPolicy = false;
            }
        },
        
        // Handle pagination change
        onPageChange(page) {
            if (this.loading || this.currentPage === page) {
                return;
            }
            this.currentPage = page;
            this.loadPolicies();
        },
        
        // Format datetime để hiển thị
        formatDateTime(dateTime) {
            if (!dateTime) return 'N/A';
            return new Date(dateTime).toLocaleString('en-GB', {
                day: '2-digit',
                month: '2-digit', 
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit'
            });
        },
        
        // Format date only
        formatDate(dateTime) {
            if (!dateTime) return 'N/A';
            //return new Date(dateTime).toLocaleDateString('en-GB');            
            return moment.utc(dateTime).local().format('DD/MM/YYYY');
        },
        
        // Format time only
        formatTime(dateTime) {
            if (!dateTime) return 'N/A';
            return moment.utc(dateTime).local().format('HH:mm:ss');
        },
        
        // Change status của policy
        async onChangeStatus(policy, newStatus) {
            try {
                const payload = {
                    Id: policy.id,
                    IsActive: newStatus,
                    LastModifiedBy: 'nvanh'
                };
                
                const response = await cashbackPolicyApi.changeStatus(payload);
                
                if (response.data && response.data.result === 1) {
                    if (this.$message) {
                        this.$message.success(
                            newStatus ? 'Policy activated successfully!' : 'Policy deactivated successfully!'
                        );
                    }
                    // Update local data
                    policy.isActive = newStatus;
                } else {
                    if (this.$message) {
                        this.$message.error('Failed to change status: ' + (response.data && response.data.message || 'Unknown error'));
                    }
                    // Revert switch state if API fails
                    this.$nextTick(() => {
                        // Force re-render component to revert switch
                        this.$forceUpdate();
                    });
                }
            } catch (error) {
                console.error('Error changing status:', error);
                if (this.$message) {
                    this.$message.error('Error changing status: ' + error.message);
                }
                // Revert switch state if API fails
                this.$nextTick(() => {
                    this.$forceUpdate();
                });
            }
        },
        
        // Delete policy với confirmation
        deletePolicy(policy) {
            // Kiểm tra nếu policy đang active
            if (policy.isActive) {
                if (this.$message) {
                    this.$message.warning('Cannot delete active policy. Please deactivate it first.');
                }
                return;
            }
            
            // Confirmation dialog
            this.$confirm(
                `Are you sure you want to delete policy "${policy.name}"? This action cannot be undone.`,
                'Delete Policy',
                {
                    confirmButtonText: 'Delete',
                    cancelButtonText: 'Cancel',
                    type: 'warning',
                    confirmButtonClass: 'el-button--danger'
                }
            ).then(async () => {
                try {
                    const response = await cashbackPolicyApi.deletePolicy(policy.id);
                    
                    if (response.data && response.data.result === 1) {
                        if (this.$message) {
                            this.$message.success('Policy deleted successfully!');
                        }
                        // Reload danh sách sau khi xóa
                        if (!this.loading) {
                            await this.loadPolicies();
                        }
                    } else {
                        if (this.$message) {
                            this.$message.error('Failed to delete policy: ' + (response.data && response.data.message || 'Unknown error'));
                        }
                    }
                } catch (error) {
                    console.error('Error deleting policy:', error);
                    if (this.$message) {
                        this.$message.error('Error deleting policy: ' + error.message);
                    }
                }
            }).catch(() => {
                // User cancelled - không cần làm gì
            });
        }
    },
}